<template>
  <b-button
    v-bind="$attrs"
    :disabled="disabled || loading"
    @click="clickEvent"
    :variant="variant"
    class="font-weight-bold text-md line-height-md ap-button"
  >
    <b-spinner v-if="loading" small class="mr-2 ml-2"></b-spinner>
    <Transition name="fade">
      <b-icon v-if="showSuccessIcon && !loading" class="mr-2 ml-2" icon="check"></b-icon>
    </Transition>
    <slot></slot>
  </b-button>
</template>

<script setup lang="ts">
type Props = {
  loading?: boolean
  disabled?: boolean
  variant?: string
  showSuccessIcon?: boolean
}

type Emits = {
  click: []
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary'
})

const emit = defineEmits<Emits>()

function clickEvent() {
  if (props.loading || props.disabled) return
  emit('click')
}
</script>

<style lang="scss">
.ap-button {
  box-sizing: border-box;
}
</style>
